'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */
const AccordionContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}
export default AccordionContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Accordion/AccordionContext.js
// module id = 877
// module chunks = 25